import { render } from "./AccessControlManager.vue?vue&type=template&id=918f77ea&scoped=true"
import script from "./AccessControlManager.vue?vue&type=script&lang=js"
export * from "./AccessControlManager.vue?vue&type=script&lang=js"

import "./AccessControlManager.vue?vue&type=style&index=0&id=918f77ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918f77ea"]])

export default __exports__